import React, { useState, useEffect, forwardRef, useRef, Fragment } from "react";
import { Button } from '../../components/Wrappers'
import { TextField, InputAdornment,
         FormControl, InputLabel, Select, Input, Chip, MenuItem,
         NativeSelect} from "@material-ui/core";
import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Icons
import {
    CalendarToday as CalendarTodayIcon,
    HomeWork as HomeWorkIcon
} from '@material-ui/icons'

import { useUserState } from "../../context/UserContext";
import useStyles from './styles';
import config from '../../config';
import classnames from "classnames";
import "./Operational.css";

registerLocale('en-NZ', enNZ);


const Operational = forwardRef((props, ref) => {
    var classes = useStyles();
    var { regions } = useUserState();
    const dateRef = useRef(null);
    const dateCalendarRef = useRef(null);
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [dateFocused, setDateFocused] = React.useState(false);
    const toRef = useRef(null);
    const toCalendarRef = useRef(null);
    var currentDateValue = null;
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [regionSelectionOpen, setRegionSelectionOpen] = React.useState(false);
    const [selectedIsAll, setSelectedIsAll] = React.useState('YES');

    const adminRoles = JSON.parse(localStorage.getItem("admin_roles"));
    const masterRole = adminRoles?.includes("MASTER_SUMMARY");

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    useEffect(() => {
        const today = new Date();

        // start with previous day
        const d = new Date(today);
        d.setDate(today.getDate() - 1);

        // if Sunday (0), roll back to Saturday
        if (d.getDay() === 0) {
          d.setDate(d.getDate() - 1);
        }

        setSelectedDate(d);
    }, []);


    const handleChange = (event) => {
        setSelectedRegion(event.target.value);
    };

    const handleDelete = () => {
      setSelectedRegion(null);
    };


    const onMouseDown = e => {
      e.stopPropagation();
    };

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeDate(d) {
      currentDateValue = d;
    }

    function onFocusDate(event) {
      setDateFocused(true);
    }


    function blurDate(event) {
      setDateFocused(false);
    }

    function handleSelectDate(d) {
      setSelectedDate(d);
    }


    // triggered if use keyboard
    function handleDateKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setDateFocused(false);
      }
    }

    function handleChangeIsAll(e) {
      const value = e.target.value;
      setSelectedIsAll(value);

      if (value === 'YES') {
        setSelectedRegion(null);
      }
    }

    function formatDateYYYYMMDD(d) {
      if (!d) return null;

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }



    function generateOperationalReport() {
        const dateStr = formatDateYYYYMMDD(selectedDate);

        const dateParam = dateStr ? `date=${dateStr}` : null;

        const regionParam =
          selectedRegion && selectedRegion.id
            ? `region_id=${selectedRegion.id}`
            : null;

        const baseUrl = `${config.clientApi}/report/daily_summary_workbook`;

        const params = [dateParam, regionParam]
          .filter(Boolean)
          .join('&');

        const url = params ? `${baseUrl}?${params}` : baseUrl;

        console.log(url);
        window.open(url, '_blank');
    }




    return (
      <>

                <div className={classes.reportCalendars}>
                    <TextField
                      id="date"
                      ref={dateRef}
                      label="Date"
                      className={classnames({
                      'textField': true,
                      'reportCalendarField': true,
                      [classes.calendarFocused]: dateFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={dateCalendarRef}
                          className={classes.textField}
                          selected={selectedDate}
                          onChange={handleChangeDate}
                          onFocus={onFocusDate}
                          onSelect={handleSelectDate}
                          onClickOutside={blurDate}
                          onKeyDown={handleDateKeyPress}
                          locale="en-NZ"
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy"
                          />
                        }}
                    />

                </div>

                {!masterRole && (
                      <>


                <FormControl variant="outlined" className={classnames({
                      'isAllRegionsSelect':  true,
                      'operational-select-control': true
                    })}>
                  <InputLabel id="is_all">All Regions?</InputLabel>
                  <div className={classnames({
                                'select-control-input': true
                              })}>
                    <NativeSelect
                      value={selectedIsAll}
                      onChange={handleChangeIsAll}
                    >
                       <option value="YES">YES</option>
                       <option value="NO">NO</option>
                    </NativeSelect>
                  </div>
                </FormControl>

                {selectedIsAll === 'NO' && <FormControl variant="outlined"
                             className={classnames(classes.regions, {
                              'regions-control': true
                            })}>
                  <InputLabel id="regions-label">Regions</InputLabel>
                  <div className={classnames(classes.regionsInput, {
                                'regions-control-input': true
                              })}>
                  <InputAdornment position="start">
                    <HomeWorkIcon />
                  </InputAdornment>
                  <Select
                      labelId="regions-label"
                      id="region"
                      className={classes.regionsSelect}
                      value={selectedRegion}
                      onChange={(e) => {
                        setSelectedRegion(e.target.value);
                        setRegionSelectionOpen(false);
                      }}
                      open={regionSelectionOpen}
                      onClose={() => setRegionSelectionOpen(false)}
                      onOpen={() => setRegionSelectionOpen(true)}
                      input={<Input id="region-chip" />}
                      renderValue={(selected) =>
                        selected ? (
                          <Chip
                            label={selected.name}
                            className={classes.chip}
                            variant="outlined"
                            onMouseDown={onMouseDown}
                          />
                        ) : null
                      }
                      MenuProps={MenuProps}
                      size="small"
                    >
                      {regions && regions.map(region => (
                        <MenuItem
                          key={region.id}
                          value={region}
                          onClick={() => setRegionSelectionOpen(false)}
                        >
                          <span className="dropdown-avatar">{region.name}</span>
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </FormControl>}
                </>
                )}

                <div className={classes.layoutButtonsRow}>
                    <Button onClick={generateOperationalReport} >
                      <span>create</span>
                    </Button>
                </div>

      </>
    );
});

export default Operational;
